export const STATUS_CREATE_JOB = 'CREATEJOB';

export const STATUS_UPLOAD_FILE = 'UPLOAD_FILE';
